import { FC, useContext, useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import {
  AssociateApprovalStatus,
  AuthenticationContext,
} from '@vs-online-only-app/state';
import PostsList from './PostsList';
import { CloseButton } from './PostCard';
import IntroModulesAsPosts from './IntroModulesAsPosts';

const PostsHeader = styled(Stack)`
  position: sticky;
  top: -${({ theme }) => theme.spacing(3)};
  flex-direction: row;
  background-color: ${({ theme }) => theme.palette.background.paper};
  z-index: 100;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(2, 0)};
`;

const Posts: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { user } = useContext(AuthenticationContext);
  const isApproved = user?.approvalStatus === AssociateApprovalStatus.Approved;

  const open = () => setIsModalOpen(true);
  const onClose = () => setIsModalOpen(false);

  return (
    <Stack position="relative">
      <PostsHeader>
        <Typography fontWeight="bold" variant="h5">
          For you
        </Typography>
        <Button size="small" onClick={open}>
          See all
        </Button>
      </PostsHeader>
      {isApproved ? <PostsList /> : <IntroModulesAsPosts />}
      <Dialog open={isModalOpen} onClose={onClose} fullWidth maxWidth="sm">
        <CloseButton onClick={onClose} size="small">
          <Close fontSize="small" />
        </CloseButton>
        <DialogTitle>All posts</DialogTitle>
        <DialogContent>
          {isApproved ? <PostsList paginate /> : <IntroModulesAsPosts />}
        </DialogContent>
      </Dialog>
    </Stack>
  );
};

export default Posts;
